import { io } from "socket.io-client";

const hostname = window.location.hostname;
let url;

if (hostname === "dev.scrollx.io") {
  url = "https://dev.api.scrollx.io";
} else if (hostname === "localhost") {
  url = "http://localhost:8000";
} else {
  url = "https://api.scrollx.io";
}

const socket = io(url, {
  autoConnect: false,
});

const getAuthToken = () => {
  const storedToken = localStorage.getItem("authToken");
  if (!storedToken) return null;

  try {
    return JSON.parse(storedToken);
  } catch (_error) {
    return storedToken;
  }
};

export const configureSocketAuth = (socketInstance = socket) => {
  const authToken = getAuthToken();
  socketInstance.auth = authToken ? { authToken } : {};
  return Boolean(authToken);
};

export default socket;
